import styled, { DefaultTheme, createGlobalStyle, css } from 'styled-components';

import media from '../../utils/styling/media';
import MainContent from '../../components/layout/MainContent';
import SideNav from '../../components/navigation/SideNav';
import IconButton from '../../components/buttons/IconButton';

export const LayoutGlobalStyles = createGlobalStyle`
  body {
    overlow-x: hidden;
  }
`;

export const StyledSideNavLayout = styled.div<{ isBigScreen: boolean; navTopBorder?: string }>`
  font-family: ${({ theme }) => theme.fontFamily.regular};
  color: ${({ theme }) => theme.colors.text};
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  /* Fix for IE11 */
  height: 1px;

  ${({ isBigScreen, navTopBorder }) => isBigScreen && css`
    ${SideNav.StyledNav} {
      border-top: ${({ theme }) => navTopBorder || `1px ${theme.colors.gray3} solid`};
    }
  `}

  > * {
    flex-shrink: 0;
  }
`;

export const StyledDrawerSideNav = styled(SideNav)<{ theme: DefaultTheme }>`
`;

export const StyledContentWrapper = styled.div<{contentBackground: string}>`
  flex: 1;
  display: flex;
  flex-direction: row;
  background: ${({ contentBackground, theme }) => contentBackground || theme.colors.green13};
  flex-grow: 1;
`;

export const StyledContent = styled(MainContent)`
  flex: 1;
`;

export const StyledContentNavWrapper = styled.div<{ fullHeight: boolean }>`
  display: flex;

  ${({ fullHeight }) => fullHeight && css`
    flex: 1;
  `}
`;

export const StyledContentNavContentWrapper = styled.div<{ fullHeight: boolean }>`
  flex: 1;

  ${({ fullHeight }) => fullHeight && css`
    display: flex;
    flex-direction: column;
  `}
`;

export const StyledIconButton = styled(IconButton)`
  ${media.md`
    position: relative;
    left: -16px;
  `}
`;

export const StyledNavCol = styled.div<{ navColBackground?: string; minWidth: number; maxWidth: number; sideNavPosition: 'content' | 'contentWrapper'; sideNavColRightPadding: number }>`
  background: ${({ navColBackground, theme }) => navColBackground || theme.colors.white50};
  padding: 60px 0;
  flex-shrink: 0;
  min-width: ${({ minWidth }) => minWidth}px;

  ${({ sideNavPosition }) => sideNavPosition === 'content' && css`
    padding: 0;
  `}

  ${({ sideNavColRightPadding }) => sideNavColRightPadding && css`
    padding-right: ${sideNavColRightPadding}px;
  `}

  ${media.lg<{ maxWidth: number }>`
    max-width: ${({ maxWidth }) => maxWidth}px;;
  `}
`;

export const StyledContentCol = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;
